import { ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { Box } from '@mui/system'
import Chip from 'Theme/Chip'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

const useStyles = makeStyles((theme) => ({
  listItem: {
    borderRadius: '4px',
    cursor: 'pointer',
    height: '40px',
    margin: '3px 0',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.05)',
      '& .MuiTypography-root': {
        color: theme.palette.text.primary,
      },
    },
  },
  icon: {
    minWidth: 0,
    marginRight: '10px',
  },
}))

export const ActionsPopperItem = ({ onClick, title, icon, chipTitle, isExpand, color, iconColor, isChecked }) => {
  const classes = useStyles()
  return (
    <ListItem
      classes={{ root: classes.listItem }}
      onClick={onClick}
    >
      {icon && (
        <ListItemIcon className={classes.icon}>
          <FAIcon
            iconFontSize={16}
            iconClassName={icon || ''}
            color={iconColor || color}
          />
        </ListItemIcon>
      )}
      <ListItemText>
        <Box
          gap={1.5}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography
            variant="button"
            color={color}
            sx={{
              maxWidth: 160,
            }}
          >
            {title}
          </Typography>
          {chipTitle && (
            <Chip
              label={
                <Typography
                  variant="overline"
                  color="text.secondary"
                  fontWeight={900}
                >
                  {chipTitle}
                </Typography>
              }
              sx={{
                padding: '6px 12px',
                backgroundColor: 'rgba(0, 0, 0, 0.25)',
                height: '24px',
                width: '65px',
              }}
            />
          )}
          {isExpand && (
            <FAIcon
              iconFontSize={14}
              iconClassName={FA_ICONS.CARET_UP}
              style={{ transform: 'rotate(90deg)' }}
            />
          )}
          {isChecked && (
            <FAIcon
              iconFontSize={16}
              iconClassName={FA_ICONS.CHECK}
              color="secondary.main"
            />
          )}
        </Box>
      </ListItemText>
    </ListItem>
  )
}
